// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"318":"ef96aabd","377":"a9b707f4","409":"931cc2d4","685":"a7c78620","811":"f7a553f8","893":"0cf06a8b"}[chunkId] + ".chunk.js";
};